export const OPEN_BET_HISTORY = 'bet-history:open';
